import BiteClassification from 'components/Patients/BiteClassification/BiteClassification'
import useBiteClassification from 'hooks/useBiteClassification'
import { isCompleteBiteClassification } from 'utils/biteClassificationUtils'
import { Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import GrinChip from 'components/common/GrinChip'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import OffTrackGrinScanItem from 'components/common/icons/timelineV2/mini-timeline/OffTrackGrinScanItem'
import OnTrackGrinScanItem from 'components/common/icons/timelineV2/mini-timeline/OnTrackGrinScanItem'
import HiConditionList from 'components/Patients/Chat/MessageTypes/HI/HiConditionsList'
import { TreatmentTrackOptions } from 'consts/giConsts'
import { ScanFeedPageSectionNames } from 'consts/timelineConsts'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ScanFeedCard from './ScanFeedCard'

const useStyles = makeStyles(theme => ({
  content: { display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', justifyContent: 'space-between', gap: 20 },
  details: { flex: '1 1 140px', minWidth: 0 },
  scanTrackingCardHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: ({ trackStatus }) => (trackStatus === TreatmentTrackOptions.OnTrack ? 8 : 24)
  },
  trackStatusIcon: {
    marginRight: 8,
    lineHeight: 0.8
  }
}))

const ScanTrackingCard = ({ trackStatus = '', conditions = [], notes = '', biteClassification }) => {
  const classes = useStyles({ trackStatus })
  const { t } = useTranslation()
  const { isEnabled } = useBiteClassification()

  return (
    <ScanFeedCard id={ScanFeedPageSectionNames.ScanTracking}>
      <div className={classes.content}>
        <div className={classes.details}>
          <div className={classes.scanTrackingCardHeader}>
            <div className={classes.trackStatusIcon}>
              {trackStatus === TreatmentTrackOptions.OnTrack ? <OnTrackGrinScanItem /> : <OffTrackGrinScanItem />}
            </div>
            <DazzedParagraph14 bold>
              {t(`pages.patients.selectedPatient.timelineV2.trackStatus.${trackStatus}`)}
            </DazzedParagraph14>
          </div>
          <Grid container direction="column" spacing={1}>
            <Grid item>
              <HiConditionList conditions={conditions} />
            </Grid>
            {notes && (
              <Grid item>
                <GrinChip text={notes} />
              </Grid>
            )}
          </Grid>
        </div>
        {isEnabled && isCompleteBiteClassification(biteClassification) && (
          <BiteClassification value={biteClassification} variant="scan" />
        )}
      </div>
    </ScanFeedCard>
  )
}

export default ScanTrackingCard
